import script from "./Home.vue?vue&type=script&setup=true&lang=js"
export * from "./Home.vue?vue&type=script&setup=true&lang=js"

import "./Home.vue?vue&type=style&index=0&id=91d7c7d6&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2210302582/src/abingtonheightstownhomes/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-91d7c7d6"]])

export default __exports__